import React from 'react';
import VerifyEmail from '../VerifyEmail';
import queryString from 'query-string';
import UpdatePassword from '../UpdatePassword';
const Action = (props) => {
    const query = queryString.parse(props.location.search);
    const mode = query.mode;

    const actionCode = query.oobCode;


    switch (mode) {
        case 'verifyEmail':
            // Display email verification handler and UI.
            return <VerifyEmail actionCode={actionCode} />;
        case 'resetPassword':
            // Display email recovery handler and UI.
            return <UpdatePassword actionCode={actionCode} />;
        default:
            // Error: invalid mode.
            return (
                <div className="Action">
                    <h1>Error encountered</h1>
                    <p>The selected page mode is invalid.</p>
                </div>
            );
    }
}

export default Action;


// WEBPACK FOOTER //
// ./src/components/Action/index.js